import CONSTANTS from './constants';


const vUtils = {
//Test written
    comparison:  ( field, comparator, valueTarget) => {
        switch (comparator) {
            case 'not_equal' :
                return field.toLowerCase() !== valueTarget.toLowerCase();
            case 'contains':
                return (field.toLowerCase().indexOf(valueTarget.toLowerCase()) > -1);
            default:
                //equals
                return field.toLowerCase() === valueTarget.toLowerCase();
        }
    },
    
//Test written
    replaceTokens: (arrayItem, fields) => {
        //first, split into array on semi-colons
        if(arrayItem && arrayItem.indexOf('**') > -1) {
            let thefieldItems = arrayItem.split('**');
            if(thefieldItems.length > 1){
                return vUtils.replaceTheFieldValueFromName(fields,thefieldItems[1]);
            }
        }

        return arrayItem;
    },

 //Test written
    replaceFieldRefWithValue: (fieldStr, fields) => {
        //returns an array for a pyramid viz based on the meta field pyramidFilterString
        
        if(!fieldStr || fieldStr.length < 1) {
            return '';
        }

        //TODO: confirm within dotted line is still needed and not specific to when we were using pyramid-------------------------------------------------------------
        //first, if there are multiples, split on semi-colons
        if(fieldStr.indexOf(';') > -1) {
            let multipleItems = fieldStr.split(';');
            if(multipleItems.length > 1) {
                return multipleItems.map( (thisItem) => {
                    return vUtils.replaceTokens(thisItem.trim(), fields);
                })
            } 
        }//-------------------------------------------------------------------------------------------------------------------------------------------------------
        return [vUtils.replaceTokens(fieldStr, fields)];
    },

//Test written
    filterForApplicableOverrides: (overrideArray, contentFields, tenant) => {
        //first, check tenant on override, if not set then is universal
        if (overrideArray && overrideArray.length > 0) {
            let usedOverrides = overrideArray.filter( (thisOvr) => {
                return (thisOvr && !thisOvr.specificToTenant_TextField) || 
                        thisOvr.specificToTenant_TextField.toLowerCase() === tenant.tenant.fields.tenantslug.toLowerCase();
            })
    
            //then check to see if matches this particular item
    
            usedOverrides = usedOverrides.filter( (thisOverride) => {
                return vUtils.comparison(contentFields.fields[thisOverride.conditionFieldName], thisOverride.conditionOperator, thisOverride.conditionValue);
            })
    
    
            return usedOverrides;
        }
    },

 //Test written
    getOptionsForPBI: (fieldDescr, fields, tenant, defaultVizHeight, models) => {
        let retObj = { reportID: '', datasetID: '' };
        let filtersToAdd;

        retObj.defaultHeight = defaultVizHeight;

        retObj.tenID = tenant && tenant.tenant && tenant.tenant.fields && tenant.tenant.fields.aDGroupID ? tenant.tenant.fields.aDGroupID : null;

        //temp fields called pBIReportID and pBIDatasetID

        if(fieldDescr.pBIReportID && fieldDescr.pBIDatasetID) {
            retObj.reportID = fieldDescr.pBIReportID;
            retObj.datasetID = fieldDescr.pBIDatasetID;
        }

        let pbiFiltersForReport = null

        if(fieldDescr.pBI_Filter && fieldDescr.pBI_Filter.length > 0) {
            pbiFiltersForReport = fieldDescr.pBI_Filter;
        } else if (fieldDescr.pBIFilter && fieldDescr.pBIFilter.length > 0) {
            pbiFiltersForReport = fieldDescr.pBIFilter;
        }
        
        if (pbiFiltersForReport) {
            //filters for this power bi viz
            filtersToAdd = pbiFiltersForReport.map( (thisFilter) => {
                let valuesForFilters = vUtils.formatForProperType(vUtils.replaceFieldRefWithValue(thisFilter.fields.filterValues, fields), thisFilter.fields.typeOfValueExpected ? thisFilter.fields.typeOfValueExpected : null)
                let retSchema;

                let formatFilter;
                if (thisFilter.fields) {
                    formatFilter = thisFilter.fields;
                } else {
                    formatFilter = thisFilter;
                }

                if(formatFilter.operator === 'Or' || formatFilter.operator === 'And') {
                    retSchema = vUtils.getSchemaForPBI(models.FilterType.Advanced, valuesForFilters, formatFilter, models)
                } else {
                    retSchema = vUtils.getSchemaForPBI(models.FilterType.Basic, valuesForFilters, formatFilter, models)
                }   
                
                return retSchema
            });
        }

        //check overrides
            let functionalOverrides = vUtils.filterForApplicableOverrides(fieldDescr.overrides, fields, tenant);

        if(functionalOverrides && functionalOverrides.length > 0) {
            functionalOverrides.forEach( (thisOverride) => {
                if(thisOverride.pBIReportID && thisOverride.pBIDatasetID) {
                    retObj.reportID = thisOverride.pBIReportID;
                    retObj.datasetID = thisOverride.pBIDatasetID;
                }

                if(thisOverride.pBI_Override_Filters){
                    //filters for this power bi viz
                    filtersToAdd = thisOverride.pBI_Override_Filters.map( (thisFilter) => {

                        let valuesForFilters = vUtils.formatForProperType(vUtils.replaceFieldRefWithValue(thisFilter.filterValues, fields), thisFilter.typeOfValueExpected ? thisFilter.typeOfValueExpected : null)
                        
                        let retSchema;

                        let formatFilter;
                        if (thisFilter.fields) {
                            formatFilter = thisFilter.fields;
                        } else {
                            formatFilter = thisFilter;
                        }
                        
                        if(formatFilter.operator === 'Or' || formatFilter.operator === 'And') {
                            retSchema = vUtils.getSchemaForPBI(models.FilterType.Advanced, valuesForFilters, formatFilter, models)
                        } else {
                            retSchema = vUtils.getSchemaForPBI(models.FilterType.Basic, valuesForFilters, formatFilter, models)
                        }   
                        
                        return retSchema;
                    });

                }
            });
        }

        retObj.filters = filtersToAdd;
        return retObj;
    },


    //this function is used to get the embed data for a Power BI report or dataset, looking first in localStorage 
    // for a cached version, and if not found or expired, fetching it from the bi API.
    getEmbedData: async function (reportID, datasetID, tenID, tokenForUse, reportType='report') {
        // first, check for valid cached info in localStorage, use that if it exists
        if (reportID && datasetID) {
            // let cachedEmbedData = localStorage.getItem(`${reportID}--${datasetID}`);
            // if (cachedEmbedData) {

            //     cachedEmbedData = JSON.parse(cachedEmbedData);
            //     // check the cache stamp to see if it is expired
            //     let curTime = new Date().getTime();
            //     let cachedExpTime = cachedEmbedData.cacheStamp ? parseInt(cachedEmbedData?.cacheStamp) : curTime;

            //     // if the cache is expired, we need to get a new token
            //     if (curTime < cachedExpTime) {
            //         return cachedEmbedData;
            //     }
            // }

            // if not there or expired, get from bi
            try {
                let tenPassedParam = tenID ? `&tenid=${tenID}` : '';

                let res = await fetch(`${process.env.REACT_APP_WEB_API_B2C}/api/bi?reportid=${reportID}&datasetid=${datasetID}&reportType=${reportType}${tenPassedParam}`,
                    {
                        method: 'GET',
                        headers: { "Authorization": "Bearer "+ tokenForUse.accessToken ? tokenForUse.accessToken : tokenForUse }
                });
        
                let resJSON = await res.json();
    
                // write to localStorage - new time is current time + 1 hour (3600000 ms)
                // let newItem = {
                //     cacheStamp: new Date().getTime() + CONSTANTS.EXPIRATION_TIME, // add the expiresIn to the current time to get the expiration time
                //     token: resJSON.token,
                //     embedUrl: resJSON.embedUrl
                // }
    
                // localStorage.setItem(`${reportID}--${datasetID}`, JSON.stringify(newItem));
                
                return resJSON;
            } catch (err) {
                  return null;
            }

        }

        //hail mary, we should never get here, but if we do, return null
        return null;
    },

    //Test written
    formatForProperType: (fieldValueArray, fieldType=null) => {

        let yearArr = [];
       fieldValueArray.forEach( (thisValue) => {
            if(Array.isArray(thisValue)) {
                thisValue.forEach((curVal) => {
                    if (fieldType === 'number') {
                        yearArr.push(parseInt(curVal));
                    } else {
                        yearArr.push(curVal);
                    }
                })
            } else {
                if(fieldType === 'number') {
                   yearArr.push(parseInt(thisValue));
                } else {
                    yearArr.push(thisValue);
                }
            }
        });
        return yearArr;
    },
//Test written
    getSchemaForPBI: (filterTypeToSend, valuesForFilters, filter, models) => {

        if ( filterTypeToSend === models.FilterType.Advanced){
            let conditionsArr = [
                {
                    operator: 'GreaterThanOrEqual',
                    value: valuesForFilters[0]
                },
                {
                    operator: 'LessThanOrEqual',
                    value: valuesForFilters[1]
                }
            ]
    
            return {
                $schema: `http://powerbi.com/product/schema#${filterTypeToSend}`,
                target: {
                    table: filter.targetTable,
                    column: filter.targetColumn
                },
                logicalOperator: filter.operator,
                conditions: conditionsArr,
                filterType: models.FilterType.Advanced,
                requireSingleSelection: filter.requireSingleSelection ? filter.requireSingleSelection : false
            }
        }

        if (filterTypeToSend === models.FilterType.Basic) {
            return {
                $schema: "http://powerbi.com/product/schema#basic",
                target: {
                    table: filter.targetTable,
                    column: filter.targetColumn
                },
                filterType: models.FilterType.Basic,
                operator: filter.operator,
                values: valuesForFilters,
                requireSingleSelection: filter.requireSingleSelection ? filter.requireSingleSelection : false
            }
        }
    },
    
//Test written
    filterToUsedNavs: (navs, infoID) => {
        //we just want the subnavs that are part of this group and that are power BI's
        //first, find where the infoID exists in the navs - urlForField
        let foundNav = navs.filter( (thisNav) => {
            return thisNav.subNav && thisNav.subNav.some( (thisSub) => {
                return thisSub.urlForField && thisSub.urlForField.toLowerCase() === infoID.toLowerCase();
            });
        });
    
        let pbisNavs = [];
    
        if(foundNav.length > 0 ){
            // go through the foundNav and filter pageItems to only those that are power BI's
            
            foundNav.forEach( (thisNav) => {
                thisNav.subNav.forEach( (thisSub) => {
                    thisSub.pageItems.forEach( (thisPageItem) => {
                        if(thisPageItem.fieldType && thisPageItem.fieldType.toLowerCase() === 'pbi'){
                            pbisNavs.push(thisPageItem);
                        }
                    })
                })
            });
            
        }
        return pbisNavs;
    
    },
    
    //Test written
    filterOutPageItemsThatHaveNoContent: (pageitems, fields) => {

        if(pageitems && pageitems.length > 0){
            return pageitems.filter( (thisPI) => {
                // check and make sure this is properly filtering page items
                
                return fields[thisPI.fieldAPIName] && fields[thisPI.fieldAPIName] !== '' && fields[thisPI.fieldAPIName] !== null;
            });
        } 

        return [];
    },

    //Test written
    getFieldNameFromFilterStr: (fieldName) => {
        if(!fieldName || fieldName.length < 1 ) {
            return undefined;
        }
        
        let thefieldItems = fieldName.split('**');

        if(thefieldItems.length > 1) {
            return thefieldItems[1];
        }

        return undefined;
    },

//Tested with the replaceTokens function
    replaceTheFieldValueFromName: (fieldsDisplayed, fieldName) => {
        //only continue if field exists in fields list with the appropriate field name
        //create a map of lowerCase field names to the actual field name
        let fields = fieldsDisplayed.fields;
        let fieldsList = Object.keys(fields).reduce( (acc, thisField) => {
            acc[thisField.toLowerCase()] = thisField;
            return acc;
        }, {});

        //fieldsList is now an object like this:
        // { 
        //  'fieldname1': 'fieldName1',
        //  'mysuperlongfield': 'mySuperLongField'
        //}

        //if the field name is not in the list, return empty string
        if(fieldName.length < 1 || !(fieldsList.hasOwnProperty(fieldName.toLowerCase()))) {
            return '';
        }
        return fields[fieldsList[fieldName.toLowerCase()]];
    },


    //Test written
    //first get the right branch of the fieldsDescr
    getDescriptionItem: (navArray, infoID) => {
        if(navArray && navArray.length > 0 && infoID) {
            for(let i=0; i < navArray.length; i++) {
                if(navArray[i].subNav) {
                    for(let j=0; j < navArray[i].subNav.length; j++){
                        if(navArray[i].subNav[j].urlForField && 
                            navArray[i].subNav[j].urlForField.toLowerCase() === infoID.toLowerCase()) {
                                return navArray[i].subNav[j];
                        }
                    }
                }
            }
        } else {
            //no description items with urlForField that match the infoID
            return undefined;
        }
    },

        //because apps can vary, we'll have this function
    showNewPBI: (fieldDescr, fields) => {
        return CONSTANTS.NEW_PBI_APPS.indexOf(fields.properties?.referenceName?.toLowerCase()) > -1 ||
                fieldDescr.fieldAPIName.toLowerCase() === 'pyramidape' || CONSTANTS.NEW_PBI_APPS.indexOf(fields.fields?.name?.toLowerCase()) > -1  || CONSTANTS.NEW_PBI_APPS.indexOf(fieldDescr.fieldAPIName.toLowerCase()) > -1;
    },

// test written
    sortPageItemsByOrderDisplayed: (listToSort) => {
        return listToSort.sort( (item1, item2) => {
            let compitem1 = item1.orderDisplayed || 0;
            let compitem2 = item2.orderDisplayed || 0;
            return parseInt(compitem1) - parseInt(compitem2);
        });
    },
    

    //This is for Related news
    //convert the news list to a string for the query
    convertNewsListToString: (newsList) => {
        let accumeArray = [];
        newsList.forEach((item) => {
            accumeArray.push(item.fields.tagtext)
        })
        return accumeArray.join(',')
    },
    valExistsInList: (valToCheck, listToLookAt) => {
        if (listToLookAt && listToLookAt.length > 0) {
            let fnd = listToLookAt.filter( (thisItem) => {
                return thisItem.field.toLowerCase() === valToCheck.toLowerCase();
            });
            
            return fnd.length > 0;
        }
    },
    
    takeOutFieldsInBubbles: (contentToStrip, bubbleFields) => {
        
        let returnedFields = {};
        
        Object.keys(contentToStrip).forEach( (thisProp) => {
            if(!vUtils.valExistsInList(thisProp, bubbleFields)) {
                returnedFields[thisProp] = contentToStrip[thisProp];
            }
        });
        return { fields: returnedFields };
    },
    
    getAppTitle: (tnt, appType) => {
        if (tnt &&tnt.tenant && tnt.tenant.fields && tnt.tenant.fields.apps && tnt.tenant.fields.apps.length > 0 && appType) {
            let appInQuestion = tnt.tenant.fields.apps.find( (thisApp) => {
                return thisApp.fields.apptype.toLowerCase() === appType.toLowerCase();
            });
            
            return appInQuestion && appInQuestion.fields && appInQuestion.fields.appAlternateTitle ? appInQuestion.fields.appAlternateTitle : null;
        } else {
            return null;
        }
    },
    
    
    ////---------------------------------------------------------------------------------------------------------------------------Tests needed
    getAppURL: (tnt, appType) => {

        let tenant = tnt && tnt.tenant && tnt.tenant.fields && tnt.tenant.fields.apps && tnt.tenant.fields.apps.length > 0 ? tnt : null;

        if (tenant) {
            let appInQuestion = tnt.tenant.fields.apps.find( (thisApp) => {
              return thisApp.fields.apptype.toLowerCase() === appType.toLowerCase();
            });
            return appInQuestion && appInQuestion.fields && appInQuestion.fields.customctalink ? appInQuestion.fields.customctalink: CONSTANTS.APPS_BY_APPTYPE[appType.toUpperCase()];
        } else {
            return null;
        }
    },

}


export default vUtils;
